import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';

export function bannerCardsFactory(PALETTE) {
    return {
        BannerCard: {
            eventCard: {
                clickableArea: {
                    stopClickEventPropagation: true,
                },
                container: {
                    style: {
                        minHeight: '100%',
                    },
                },
            },
            lightBannerCardDetails: generateBannerCardDetails(PALETTE.CARD_BANNER_DETAILS_LIGHT),
            darkBannerCardDetails: generateBannerCardDetails(PALETTE.CARD_BANNER_DETAILS_DARK),
        },
        BannerCardDetails: {
            secondaryTextWrapper: {
                style: {
                    ...resolveBackground(PALETTE.CARD_BANNER_INFO_SECTION_BG),
                },
            },
            secondaryText: {
                style: {
                    ...PALETTE.CARD_BANNER_INFO_TEXT,
                },
            },
        },
    };
}

function generateBannerCardDetails(CARD_DETAILS) {
    return {
        headlineText: {
            style: CARD_DETAILS.HEADER_TEXT,
        },
        primaryText: {
            style: CARD_DETAILS.MESSAGE_TEXT,
        },
        primaryButton: generatePrimaryButton(CARD_DETAILS.PRIMARY_BUTTON),
        secondaryButton: generateSecondaryButton(CARD_DETAILS.SECONDARY_BUTTON),
    };
}
